import { gsap } from "gsap";
import debounce from 'lodash.debounce';
import { lerp, map } from '../utils.js';

export default class ProductEnlarger {
	constructor(elm) {
		this.elm = elm;

        this.elm.addEventListener('click', () => {
            this.close();
        });

		this.currentEvent = null;

        this.ty = 100;

        this.image = this.elm.querySelector('[data-product-enlarger-image]');

        this.init();
	}

	init() {

        this.boundHandleMousemove = debounce(this.handleMousemove.bind(this), 0);
		window.addEventListener('mousemove', this.boundHandleMousemove);

        this.boundHandleKeys = this.handleKeys.bind(this);
        document.addEventListener('keydown', this.boundHandleKeys);

        this.calculateMouse = () => {
            if(!this.currentEvent) {
                return;
            }

            if(!this.image) {
                return;
            }

            if(!this.imageVideo) {
                return;
            }

            if(!this.imageHeight) {
                return;
            }

            if(!this.isOpened) {
                return;
            }


            this.yMin = (((this.imageHeight-window.innerHeight)/2) * -1);
            this.yMax = (this.imageHeight-window.innerHeight)/2;

            this.ty = lerp(this.ty, map(this.currentEvent.clientY, 0, window.innerHeight-0, this.yMin, this.yMax), 0.1);
            this.ty = gsap.utils.clamp(this.yMin, this.yMax, this.ty);

            gsap.to(this.imageVideo, {
                y: this.ty * -1,
                duration: 1
            });

        }

        this.addTicker();

	}

    addTicker() {
        let mm = gsap.matchMedia();

        mm.add({
            isDesktop: `(min-width: 576px)`,
            isMobile: `(max-width: 575px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)",
            hasHover: "(hover: hover) and (pointer: fine)"
          }, (context) => {

            let { isDesktop, isMobile, reduceMotion, hasHover } = context.conditions;

            if(hasHover) {
                gsap.ticker.add(this.calculateMouse);
            } else {
                gsap.ticker.remove(this.calculateMouse);
            }

        });
    }

    removeTicker() {
        gsap.ticker.remove(this.calculateMouse);
    }

    handleMousemove(e) {
        this.currentEvent = e;
    }

    handleKeys(e) {
		if (e.key === 'Escape') {
			this.close();
		}
	}

    activateImage(media) {
        if(this.isActive) {
            return;
        }

        this.isActive = true;
        this.isOpened = false;

        document.body.classList.add('body--hide-ui');

        this.media = media;
        this.activeImage = this.media.querySelector('.c-img-video');
        this.mediaRect = this.activeImage.getBoundingClientRect();
        const cloneImage = this.activeImage.cloneNode(true);

        this.image.appendChild(cloneImage);
        window.dispatchEvent(new Event('resize'));

        this.imageVideo = this.image.querySelector('.c-img-video');

        const video = this.image.querySelector('video');
        if(video) {
            video.play();
        }

        document.dispatchEvent(new CustomEvent('disable-scroll'));


        this.imageHeight = this.image.getBoundingClientRect().height;

        gsap.from(this.image, {
            y: (window.innerHeight/2 - (this.mediaRect.top + (this.mediaRect.height/2))) * -1,
            scale: this.mediaRect.width/this.image.getBoundingClientRect().width,

            duration: 1,
            ease: 'power2.inOut',
            delay: 0.5,
            onComplete: () => {
                this.isOpened = true;
                this.elm.classList.add('is-opened');
            }
        });

        setTimeout(() => {
            this.elm.closest('[data-product-content]').classList.add('has-enlarger');
            this.elm.classList.add('is-open');

            this.image.classList.add('is-active');
        }, 100);

    }

    close() {
        if(!this.isOpened) {
            return;
        }

        this.isOpened = false;
        this.elm.classList.remove('is-opened');

        gsap.to(this.imageVideo, {
            y: 0,

            duration: 1,
            delay: 0.5,
            ease: 'power2.inOut',
        });

        this.mediaRect = this.activeImage.getBoundingClientRect();

        gsap.to(this.image, {
            y: (window.innerHeight/2 - (this.mediaRect.top + (this.mediaRect.height/2))) * -1,
            scale: this.mediaRect.width/this.image.getBoundingClientRect().width,

            duration: 1,
            delay: 0.5,
            ease: 'power2.inOut',
            onComplete: () => {
                this.elm.closest('[data-product-content]').classList.remove('has-enlarger');
                document.body.classList.remove('body--hide-ui');

                setTimeout(() => {
                    this.elm.classList.remove('is-open');
                    this.image.classList.remove('is-active');

                    gsap.set(this.image, {
                        y: 0,
                        scale: 1,
                        onComplete: () => {
                            this.image.innerHTML = '';
                        }
                    });

                    gsap.set(this.imageVideo, {
                        y: 0,
                        onComplete: () => {
                            this.imageVideo = null;
                        }
                    });

                    document.dispatchEvent(new CustomEvent('enable-scroll'));

                    this.isActive = false;

                }, 500);

            }
        });

    }

    destroy() {
        window.removeEventListener('mousemove', this.boundHandleMousemove);
        document.removeEventListener('keydown', this.boundHandleKeys);

        this.close();

        this.removeTicker();
    }
}